export const categories = [
  'comments',
  'discussions',
  'likes',
  'custom_levels_exp_logs',
  'invite_user_invites',
  'store_purchases',
  'polls_create_polls',
  'polls_votes',
  'username_requests_username',
  'username_requests_nickname',
  'best_answer_marked',
  'badges_assigned',
  'achievements_achieved',
  'quest_done'
];